import { createContext, useState, useEffect, useCallback, useMemo } from 'react';

// Create the context object with a default value
export const UnitSystemContext = createContext({
  unitSystem: 'metric',
  toggleUnitSystem: () => {}
});

export const UnitSystemProvider = ({ default_unit_system, children }) => {
  const [unitSystem, setUnitSystem] = useState(default_unit_system);
  // Effect to load the initial unit system from localStorage
  useEffect(() => {
    const savedUnitSystem = localStorage.getItem('unitSystem');
    if (savedUnitSystem) {
      setUnitSystem(savedUnitSystem);
    }
  }, []);

  // Function to toggle unit system and save it to localStorage
  const toggleUnitSystem = useCallback(() => {
    const newUnitSystem = unitSystem === 'metric' ? 'imperial' : 'metric';
    setUnitSystem(newUnitSystem);
    localStorage.setItem('unitSystem', newUnitSystem);
  }, [unitSystem]);

  const value = useMemo(() => ({ unitSystem, toggleUnitSystem }), [unitSystem, toggleUnitSystem]);

  return <UnitSystemContext.Provider value={value}>{children}</UnitSystemContext.Provider>;
};
